import views from "./views";
import components from "./components";
import others from "./others";
import managerDashboardModules from "./managerDashboardModules";

export default {
  views,
  components,
  others,
  managerDashboardModules,
};
